<template>
  <ButtonTooltip
    icon
    color="rgba(0, 0, 0, 0.54)"
    x-small
    icon-name="fa-house"
    tooltip-text="Home"
    :href="`/`"
  />
</template>

<script>
import ButtonTooltip from "@evercam/shared/components/ButtonTooltip.vue"

export default {
  name: "HomeButton",
  components: { ButtonTooltip },
}
</script>
